































































































































































































































































































































import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCardGroup,
  BCardHeader,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BRow,
  BSpinner,
  VBTooltip,
} from "bootstrap-vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    BSpinner,
    BCard,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BCardGroup,
    FormWizard,
    BCardHeader,
    BAlert,
    FeatherIcon,
    BCol,
    BFormInput,
    BRow,
    TabContent,
    BButton,
    BFormCheckbox,
    BFormGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  name: "prise-rdv-config",
})
export default class PriseRdvConfig extends Vue {
  @Prop({ required: true }) model!: any;
  @Prop({ required: true }) sitesConfig!: any[];
  @Prop({ required: true }) intervenantsConfig!: any[];
  @Prop({ required: true }) loadingSites!: boolean;
  @Prop({ required: true }) loadingIntervenants!: boolean;
  @Prop({ required: true }) rdv!: boolean;

  localRdv: boolean = this.rdv;

  @Watch('rdv')
  onRdvPropChanged(val: boolean) {
    this.localRdv = val;
  }

  onRdvChange(checked: boolean) {
    this.$emit('update:rdv', checked);
    this.togglePriseRdvModal(checked);
  }

  hasActivePriseRdvConfiguration(): boolean {
    return (
      this.model.priseDeRdvConfig != null &&
      this.model.priseDeRdvConfig.intervenants &&
      this.model.priseDeRdvConfig.intervenants.length > 0
    );
  }

  togglePriseRdvModal(checked: boolean) {
    if (checked) {
      this.$bvModal.show("rdv-stepper-modal");
      this.$emit("load-sites");
    } else if (this.hasActivePriseRdvConfiguration()) {
      this.confirmDisableRdv();
    }
  }

  confirmDisableRdv() {
    this.$bvModal
      .msgBoxConfirm(
        "Êtes-vous sûr de vouloir supprimer la configuration actuelle ?",
        {
          title: "Confirmation de suppression",
          size: "sm",
          okVariant: "primary",
          okTitle: "Oui",
          cancelTitle: "Non",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        }
      )
      .then((value: boolean) => {
        if (value === true) {
          this.$emit("disable", null);
        } else {
          this.$emit("update:rdv", true);
        }
      });
  }

  editCurrentConfiguration() {
    this.$emit("edit");
  }

  handleRdvModalClose() {
    this.$emit("close");
  }

  synchronizeConfiguration() {
    this.$emit("synchronize");
  }

  saveRdvConfiguration() {
    this.$emit("save");
  }

  handleSiteSelection(site: any) {
    this.$emit("site-selection", site);
  }

  handleIntervenantSelection(intervenant: any) {
    this.$emit("intervenant-selection", intervenant);
  }

  getAvailableIntervenantsBySite(siteId: string) {
    return this.intervenantsConfig.filter((i: any) => i.siteId === siteId);
  }

  getDefaultMission(type: number): string {
    switch (type) {
      case 1:
        return "Assistant-e de service social";
      case 2:
        return "Infirmier-e en santé travail";
      case 3:
        return "Psychologue du travail";
      default:
        return "Consultant-e";
    }
  }
}
